<script>
	// TO DO:
	// [ ] REMOVE BORDER STYLING AFTER CLICK
	// [ ] CLOSE MENU ONCLICK OUTSIDE LIST ITEMS
	// [ ] Fix bug - Logo moving left on menu open (likely due to something getting destroyed when clicked)
	import { onMount } from 'svelte';
	import { fly, fade, slide, blur } from 'svelte/transition';
	import { Tween } from 'svelte/motion';
	import { cubicInOut, quintIn } from 'svelte/easing';
	import { interpolatePath } from 'd3-interpolate-path';
    import { navItems } from '$lib/stores/shared.svelte.js';
	import { viewport, components } from '$lib/stores/shared.svelte.js';
	import Logo from '$images/logo-word.svg'
    import '$css';

	let { menuOpen = false } = $props();
	let navW = $state();
	let index = $state(0);
	let copied = $state(false);
	let scrollY = $state(viewport.scrollY);
	let scroll = $state(false);
	const BASE_DELAY = 400;
	const STEP_DELAY = 30;	

	// Paths
	const topLineCoords = $state(["M 2 6  L 18 6", "M 3.5 3.5 L 16.5 16.5"]);
	const botLineCoords = $state(["M 18 14 L 2 14", "M 16.5 3.5 L 3.5 16.5"]);
	let topLineState = $state(topLineCoords[0])
	let botLineState = $state(botLineCoords[0])

	// Tweened values for smooth transition
	const tween = new Tween(0, { 
		duration: 150, 
		easing: cubicInOut, 
	});

	/**
	 * @param {string} start
	 * @param {string} end
	 */

	function getPath(start, end) {
		// @ts-ignore
		const interpolator = interpolatePath(start, end);
		return interpolator(tween.current); // Morphs between paths
	};

	function toggleMenu() {
		index = 1 - index;
		tween.target = index; // Smoothly transitions between 0 and 1
		topLineState = topLineCoords[index];
		botLineState = botLineCoords[index];
		menuOpen = !menuOpen;
		components.navOpen = menuOpen;
		if (index === 1) {
			menuOpen = true;
			document.body.classList.add('noscroll');
		} else if (index === 0) {
			menuOpen = false;
			document.body.classList.remove('noscroll');
		}	
	};

  function updateViewport() {
		components.navW = navW;
	};

	onMount( () => {
		window.addEventListener('resize', updateViewport);
		updateViewport();
		return () => window.removeEventListener('resize', updateViewport)
	});

	function handleKeydown(event) {
		if (index === 1 && event.key === 'Escape') {
				toggleMenu();
		};
	};

</script>
<svelte:window on:keydown|preventDefault={handleKeydown} />

<!-- <div class="wrapper"> -->
<nav 
	class={["f align-cc" , { scroll , menuOpen }]} 
	bind:clientWidth={navW}
	transition:fly={{ y: -100, duration: 300, easing: cubicInOut }}
	>

		<button
		class="f align-cc"
		onclick={toggleMenu}
		aria-label={index ? "Open menu" : "Close menu"}
		>
			<svg 
			width="20" 
			height="20" 
			viewBox="0 0 20 20" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg"
			>
				<path 
					d={getPath(topLineCoords[0], topLineCoords[1])} 
					stroke="currentColor" 
					stroke-linecap="round" 
						/>
				<path d={getPath(botLineCoords[0], botLineCoords[1])}
						stroke="currentColor" 
						stroke-linecap="round" 
						/>
			</svg>
		</button>
</nav>
<!-- </div> -->

<!-- OPEN MENU -->
{#if index === 1}
<section 
	class="w-100p f-col align-fs f-g1" 
	>


	<ul class="w-a">
		{#each navItems as navItem, i (navItem.name)}
		<li 
			class="w-a f-row nowrap" 
			in:fade|global={{ delay: BASE_DELAY + i * STEP_DELAY, duration: 300, easing: cubicInOut}}
			out:fade|global={{ delay: BASE_DELAY * .25 + navItems.length - 1 - i * STEP_DELAY * .5, duration: 80, easing: cubicInOut}}
			>
			<a href={navItem.path} onclick={toggleMenu}>
				{navItem.name}
			</a>
		</li>		
		{/each}
	</ul>
</section>

<div class="pseudoBG" 
in:blur={{ delay: 1000 , duration: 200 , easing: cubicInOut }}
out:blur={{ delay: 60 , duration: 100 , easing: cubicInOut }}
></div>

{/if}

<style>
svg {
	width: 2.5rem;
	height: 2.5rem;
	color: var(--body-font-color);
	}
/* This controls the default color of the hamburger */

nav {
	z-index: 13;
	/* position: fixed; */
	position: relative;
	/* height: 6.25rem;
	width: 6.25rem; */
	height: 3.5rem;
	width: 3.5rem;
	/* top: 0rem; */
	/* left: clamp(3.5rem, -39.75rem + 43.125vw, 24rem); */
	/* padding: 1.5rem; */
	transition: all .3s ease;
	}

	nav.scroll {
		/* z-index: 11; */
		/* position: fixed;
		top: .25rem;
		left: clamp(3.5rem, -39.75rem + 43.125vw, 24rem);
		border-radius: .75rem;
		border-top: 1px solid white;
		background-color: hsla(0, 0%, 6%, 0.7);
		box-shadow: -0.05rem 0.1rem 0.25rem #333;
		-webkit-backdrop-filter: blur(8px);        
		backdrop-filter: blur(8px); */
	}

		nav.scroll.menuOpen {
		/* z-index: 11; */
		border-radius: .75rem;
		border-top: none;
		background-color: transparent;
		box-shadow: none;
		/* position: fixed;
		top: 4rem;
		left: clamp(3.5rem, -39.75rem + 43.125vw, 24rem); */
	}

button {
	width: 3.5rem;
	height: 3.5rem;
	background-color: transparent;
	transition: all .4s ease;
}

section {
	z-index: 10;
	position: relative;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	/* background-color: hsla(0, 0%, 0%, 1); */
}

ul {
	top: .25rem;
	left: 0;
	/* left: clamp(0.25rem, -39.75rem + 43.125vw, 24rem); */
	position: absolute;
	padding-left: 2rem;
}

ul li {
	list-style-type: none;
	padding: .75rem 0;
}

button::after {
	border: none;
}

a {
	width: 100%;
	font-size: clamp(2.875rem, -9.3306rem + 11.8172vw, 3.25rem);
	font-family: 'Inter Variable', sans-serif;
	font-weight: 300;
	color: var(--neu2);
	transition: all .4s ease;
}

a:hover {
	color: var(--neu0);
	transform: translateX( var(--space-s) );
}

div.pseudoBG {
	z-index: 9;
	position: fixed;
	left: 0;
	top: 0;
	width: 100vw;
	height: 100vh;
	background-color: var(--main-bg-color);
	/* background-color: darkcyan; */

}

@media (max-width: 768px) {
	/* .wrapper {
		width: fit-content;
		height: fit-content;
		top: 0;
		left: 0;
	} */

	nav {
		position: relative;
		width: 100%;
		padding: 0;
		border-radius: 0;
		background-color: transparent;
	}

	svg {
		width: 2.5rem;
		height: 2.5rem;
	}

	nav.scroll {
		position: relative;
		background-color: transparent;
		border-color: transparent;
		box-shadow: none;
		-webkit-backdrop-filter: none;        
		backdrop-filter: none;
	}

	nav.menuOpen {
		z-index: 11;
		position: relative;
	}

	section {
		background-color: none;
	}

	ul {
		top: 5rem;
		left: -2rem;
		padding-left: 0;
	}

	ul li {
		padding: .75rem 0;
	}

	a {
		font-size: 3.5rem;
		padding: .25rem;
		white-space: nowrap;
	}

}

</style>